module.exports = __webpack_public_path__ + "img/logomsl.61878b3a.png";